<template>
  <div class="land"
    :class="[
    `is-${landing.type}`,
    `is-${heading}`,
    { 'is-editing': isEditing }
    ]">
    <!-- TODO - replace this with a button/context menu thing -->
    <!-- <ff-snackbar class="land-share" v-if="showNotice" :text="'This site is live!'" :cta="'Share with your friends'" :copy="copy_link" @dismiss="hideShare"/> -->
    <ff-snackbar class="land-signed-up" v-if="$route.query.s && showCongrats" :text="'Thanks for subscribing, you now have unlimited access!'" @dismiss="hideNotice"/>
    <section class="land-content">
      <div class="land-content__container">
        <nav class="land-content__top-nav">
          <div class="nav-container">
            <ff-button v-if="isOwner && copy_link && !preview && !linkVisible" :action="copyShareLink" :text="shareText" :pattern="2" :icon="'share'"/>
            <input v-if="isOwner && linkVisible && copy_link && !preview" class="land-owner__copy-link" type="text" ref="share" v-model="copy_link">
          </div>
          <div class="nav-container">
            <ff-button data-test="edit-cta" v-if="!isEditing && isOwner" :text="'Edit'" :action="toggleEdit" :icon="'edit'" :pattern="2"/>
          </div>
        </nav>
        <header class="land-content__header">
          <div class="flex-container">
            <h1 class="land-content__title" data-test="landing-title">{{landing.name}}</h1>
            <h2 class="land-content__subtitle" data-test="landing-subtitle">{{landing.description}}</h2>
          </div>
          <div class="flex-container">
            <div data-test="landing-image" class="land-content__image" v-if="image" :style="`background-image: url('${image}');`"></div>
            <div data-test="landing-image" class="land-content__image is-empty" v-if="!image && isOwner && !preview" :style="`background-image: url(${image});`">
              <image-upload @upload="imageUploaded" :text="uploadText"/>
            </div>
          </div>
        </header>
        <ff-button
          v-if="!user"
          data-test="signin-landing"
          :style="{ backgroundColor: landing.color ? `#${landing.color}` : '#072FFF'}"
          class="land-content__user-signup"
          :action="userSignUp"
          :text="'Subscribe for Unlimited Access'"/>
        <!-- <ff-button
          v-if="isOwner && !preview"
          data-test="signin-landing--owner"
          v-tooltip="'Your visitors will see this if they\'re not subscribed'"
          class="land-content__user-signup is-disabled"
          :style="ownerCTAStyle"
          :action="()=>{return}"
          :text="'Subscribe for Unlimited Access'"/> -->
        <section class="land-content__grid">
          <aside class="land-content__label" v-if="publishedPages.length">
            Latest
          </aside>
          <ol class="land-content__items" v-if="publishedPages" data-test="landing-items">
            <li
              class="land-content__item"
              :class="{
                'has-image': item.cover_image,
                'is-paid': item.tier !== '' && item.tier.toLowerCase() !== 'public'
              }"
              v-for="(item, index) in publishedPages"
              :key="index" @click="navFromCard(item)">
              <aside
                class="item__locked"
                v-if="!item.tier || item.tier != 'public'">
                {{item.tier}}
              </aside>
              <div
                class="item__image"
                v-if="item.cover_image"
                :style="{
                  backgroundImage: `url('${item.cover_image}')`
                }"/>
              <div class="item__content">
                <h1 class="item__title">{{item.title}}</h1>
              </div>
              <div class="item__preview" v-if="item.content" v-html="item.content.substring(0,500).concat('...')"></div>
            </li>
          </ol>
        </section>
      </div>
    </section>
    <section class="land-edit" v-if="access && !preview && showEdit">
      <header class="land-edit__heading">
        <h1 class="land-edit__title">Edit Your Homepage</h1>
        <ff-button data-test="close-edit" :action="toggleEdit" :icon="'close'" :pattern="2"/>
      </header>
      <div class="land-edit__container">
        <ff-dropdown data-test="landing-type--dropdown" v-model="landing.type" :items="items" :action="onChange" label="Landing Page Style"/>
      </div>
      <div class="land-edit__container is-flex">
        <ff-input v-model="landing.color" :action="onChange" label="Channel Color" placeholder="Enter HEX Color Value"/>
        <span class="land-edit__color-preview" :style="{ backgroundColor: `#${landing.color}`}"></span>
      </div>
      <div class="land-edit__container">
        <ff-input data-test="landing-title--input" v-model="landing.name" :action="onChange" label="Channel Name"/>
        <ff-input data-test="landing-subtitle--input" v-model="landing.description" :action="onChange" label="Channel Description"/>
        <ff-segmented :items="[
            { text: 'Small', value: 'small' },
            { text: 'Medium', value: 'medium' },
            { text: 'Large', value: 'large' }]"
          :initialSelected="initialSize"
          :size="'small'"
          @changed="sizeChanged"/>
        <image-upload @upload="imageUploaded" :text="uploadText"/>
      </div>
      <ff-button data-test="publish-changes" v-if="changed" :action="save" :text="'Publish Changes'"/>
    </section>
    <modal-login @callback="handleCallback"/>
  </div>
</template>

<script>
const DEFAULT_HEADING = 'medium'
import persist from '../../mixins/persist'
import analytics from '../../mixins/analytics'

import { mapState } from 'vuex'
import FFButton from '../DesignSystem/FFButton'
import FFInput from '../DesignSystem/FFInput'
import FFDropdown from '../DesignSystem/FFDropdown'
import FFSnackbar from '../DesignSystem/FFSnackbar'
import FFSegmented from '../DesignSystem/FFSegmented'
import ImageUpload from '../_Shared/ImageUpload'
import ModalLogin from '../_Modals/ChannelLogin'
import { deserializeImage, serializeImage } from '../../helpers/storage'
import _ from 'lodash'

export default {
  name: 'ChannelLanding',
  mixins: [
    persist,
    analytics
  ],
  components: {
    'ff-button': FFButton,
    'ff-input': FFInput,
    'ff-dropdown': FFDropdown,
    'ff-snackbar': FFSnackbar,
    'ff-segmented': FFSegmented,
    'image-upload': ImageUpload,
    'modal-login': ModalLogin,
  },
  props: [
    'preview',
    'loading'
  ],
  data() {
    return {
      data: this.$store.state.channel,
      changed: false,
      copy_link: '',
      isOwner: false,
      show_share: true,
      showCongrats: true,
      shareText: 'Share Homepage',
      linkVisible: false,
      heading: DEFAULT_HEADING,
      showEdit: false,
      landing: {
        type: null,
        name: null,
        description: null,
        image: null,
        color: null,
        headingSize: DEFAULT_HEADING
      },
      items: [
        {
          title: 'Strong',
          value: 'strong'
        },
        {
          title: 'Creative',
          value: 'creative'
        },
        {
          title: 'Light',
          value: 'light'
        }
      ],
      image: null
    }
  },
  computed: {
    ...mapState(['user', 'channel', 'channel_id']),
    access () {
      if (!this.user || !this.channel) return false
      return this.user.uid === this.channel.owner
    },
    uploadText () {
      if (this.image) return 'Replace Image'
      return 'Upload an Image'
    },
    hasPages () {
      if (!this.channel || !this.channel.pages) return false
      return this.channel.pages.length
    },
    showNotice () {
      return !this.hasPages && this.show_share && this.access && !this.preview
    },
    initialSize () {
      if (!this.channel || !this.channel.landing || !this.channel.landing.headingSize) return DEFAULT_HEADING
      return this.channel.landing.headingSize
    },
    isEditing () {
      return !this.preview && this.isOwner && this.showEdit
    },
    publishedPages () {
      let pages = []
      _.each(this.channel.pages, (page) => {
        if (page.tier && !page.parent) {
          pages.push(page)
        }
      })
      return _.orderBy(pages, 'index')
    },
    ownerCTAStyle () {
      return {
        '--color-hover': this.landing.color ? `#${this.landing.color}` : '#072FFF'
      }
    }
  },
  methods: {
    save () {
      if (!this.access) return
      this.ChannelUpdate(this.channel_id, {
        landing: this.landing
      }, () => {
        this.changed = false
      })
    },
    imageUploaded (result) {
      if (result.success) {
        this.landing.image = serializeImage(result.file.url)
        this.landing = Object.assign({}, this.landing)
        this.image = result.file.url
        this.changed = true
      }
    },
    sizeChanged (value) {
      this.heading = value
      this.landing.headingSize = value
      return this.onChange()
    },
    onChange () {
      this.changed = true
    },
    toggleEdit () {
      this.showEdit = !this.showEdit
    },
    userSignUp () {
      this.$modal.show('login')
      this.track('[Channel] Clicked Sign Up', { location: 'landing' })
    },
    navFromCard (item) {
      return this.$router.push({name: 'page', params: { page_id: item.id }})
    },
    hideShare () {
      this.show_share = false
    },
    hideNotice () {
      this.showCongrats = false
    },
    handleCallback (data) {
      if (!data.exists) {
        return this.$router.push({name: 'channel-sign-up'})
      }
      if (this.$route.name === 'channel-landing') return
      return this.$router.push({name: 'channel-landing'})
    },
    copyShareLink () {
      this.linkVisible = true
      this.$nextTick(()=> {
        this.$refs.share.select()
        let success = document.execCommand('copy')
        let msg = success ? 'Copied' : 'Copy link'
        this.shareText = msg
        return this.swapText()
      })
    },
    swapText () {
      setTimeout(() => {
        this.shareText = 'Copy Share Link'
      }, 3000)
    }
  },
  async mounted () {
    this.isOwner = this.$store.state.channel.isOwner
    this.copy_link = `${window.location}share`

    // Open Login Modal if query matches
    if (this.$route.query && this.$route.query.login) {
      this.userSignUp()
    }

    // Create a temporary version "landing" for edits
    this.landing = this.channel.landing

    if (!this.landing) {
      this.landing = {}
    }

    this.track('[Channel] Page View', { page: 'landing' })

    // If "landing" hasn't been saved yet, populate it in
    // the database for the first time this is loaded
    if (!this.landing.name) {
      this.landing.name = this.$store.state.channel.name
      this.landing.description = this.$store.state.channel.description
      this.landing.type = 'light'
      this.landing.headingSize = DEFAULT_HEADING
      return this.save()
    }

    if (this.landing.image) {
      this.image = await deserializeImage(this.landing.image)
    }
    if (this.landing.headingSize) {
      this.heading = this.landing.headingSize
    }
  },
  watch: {
    '$route.query.login': {
      handler: function () {
        if (this.$route.query.login) this.userSignUp()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";
  @import "../../assets/styles/_mobile.scss";
</style>
